<mat-card class="p-0">
  <mat-card-title>
    <div class="card-title-text">
     Scegli Nominativo
    </div>
  </mat-card-title>
  <mat-card-content>


    <form [formGroup]='frmInserimento' class='inserimento-form'>
      <div class="container">

        <div class="row">
          <div fxFlex="33%;" fxFlex.xs="100%">
            <mat-form-field class="full-width">
              <input matInput type="text" [ngModelOptions]="{standalone: true}"
                     placeholder="Cognome" [(ngModel)]="txtCognome"
                     id="Cognome" />
            </mat-form-field>
          </div>

          <div fxFlex="33%;" fxFlex.xs="100%">
            <mat-form-field class="full-width">
              <input matInput type="text" [ngModelOptions]="{standalone: true}"
                     placeholder="Nome" [(ngModel)]="txtNome"
                     id="Nome" />
            </mat-form-field>
          </div>

          <div fxFlex="33%;" fxFlex.xs="100%">
            <button mat-raised-button color="accent"
                    (click)="btnCerca()">
              Cerca
            </button>
          </div>
        </div>



        <div class="row">
          <div class="col-md-4">
            <mat-form-field class="full-width">
              <mat-select placeholder="Cliccare sul menù a tendina per visualizzare i nominativi" formControlName="idUtentiProfilo"
                          id="idUtentiProfilo">
                <mat-option *ngFor="let obj of lstDipartimenti" [value]="obj.idUtentiProfilo">
                  {{obj.Cognome}} {{obj.Nome}} - {{obj.Email}} - {{obj.CodiceFiscale}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <br />
        <div class="row" style="float: right !important" >
          <div fxFlex="100%;" fxFlex.xs="100%">
            <button mat-raised-button color="accent"
                    (click)="btnSalva()">
              Salva
            </button>
            &nbsp;
            <button mat-raised-button color="accent"
                    (click)="btnEsci()">
              Chiudi
            </button>
          </div>
        </div>

        <!--
  <div mat-dialog-actions>
    <button mat-raised-button color="primary"
            (click)="btnAnnulla()">
      Annulla
    </button>
    <button mat-raised-button color="primary"
            [disabled]="!frmInserimento.valid"
            (click)="btnSalva()"
            cdkFocusInitial>
      Aggiungi
    </button>
  </div>-->
      </div>
    </form>
  </mat-card-content>
</mat-card>
<style>

  .inserimento-form {
    min-width: 150px;
    max-width: 720px !important;
    width: 100%;
  }

  /* .full-width {
      width: 100%;
    }*/
</style>

